import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { DropDownList } from "./DropDownList";
import { RadioButton } from "./RadioButton";
import { TextInput } from "./TextInput";
import { ExceptionsForm } from "./ExceptionsForm";
import { Button } from "@funcional/react-ui";
import { Grid } from "@material-ui/core";
import { Alert } from "./Alert";
import { IFinancialReimbursement, IOptionsData } from "../contracts";
import schema from "../validation-schema/EditFinancialRefundSchema";

export function ReadAndEditFinancialRefundForm({
    onSubmit,
    readonly,
    defaultData,
    optionsData
}: {
    onSubmit: (input: any) => Promise<void>, 
    readonly: boolean, 
    defaultData: IFinancialReimbursement,
    optionsData: IOptionsData,
  }) {
    const industryOptions = optionsData?.industryNames;
    const closureTypesOptions = optionsData?.closureTypes;
    const alertMessage = "O sistema PBM 2.0 também realizará a busca de 90 dias de período retroativo para agregar as informações de ressarcimento financeiro automático";
    const form = useForm({
      resolver: yupResolver(schema),
      defaultValues: defaultData,
    });
    
    const {
      control,
      handleSubmit,
      register,
      watch,
      setValue,
      getValues,
      formState: { errors },
    } = form;
    const watchValue = watch();

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
        <br/>
            <DropDownList 
            label = "Selecione a Indústria" 
            options = {industryOptions} 
            item = "industryName" 
            readonly={readonly}
            control={control}
            errors={errors}
            defaultValue={defaultData?.industryId}/>
            <br/><br/>
            <RadioButton 
            label = "Selecione o tipo" 
            readonly={readonly}
            control={control}/>
            <br/><br/>
            <DropDownList 
            label = "Selecione o período de fechamento" 
            options = {closureTypesOptions} 
            item = "closureType" 
            readonly={readonly}
            control={control}
            errors={errors}
            defaultValue={defaultData?.closureType}/>
            <br/>
            <Alert message = {alertMessage}/>
            <br/><br/>
            <TextInput 
            label="Dia de fechamento padrão" 
            item = "closingDay" 
            readonly={readonly}
            control={control}
            defaultData={defaultData}
            errors={errors}
            helperText="Escolha entre 1 e 31"
            watchValue={watchValue}/>
            <br/><br/>
            <ExceptionsForm
            defaultData = {defaultData?.exceptions || []}
            optionsData = {optionsData}
            control={control}
            register={register}
            errors={errors}
            readonly={readonly}
            watchValue={watchValue}
            setValue={setValue}
            getValues={getValues}/>
            <Grid item xs={12}>
                <Button color="primary" type="submit" disabled = {readonly}>
                    Salvar
                </Button>
            </Grid>
        </form>
    );
}